import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({name:"",email:"",message:""});
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", form); setDone(true); toast.success("Message sent"); }
    catch { toast.error("Error"); }
  };
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="contact-page">
      <div className="text-xs tracking-widest uppercase text-neutral-500 mb-2">Get in touch</div>
      <h1 className="font-display text-6xl text-[color:var(--hb-navy)] mb-4">Contact Us</h1>
      <p className="text-neutral-700 mb-8">Questions, partnerships, or custom orders — drop us a line.</p>
      {done ? <p className="text-[color:var(--hb-royal)]">Thanks — we'll respond within 1 business day.</p> :
      <form onSubmit={submit} className="grid gap-4" data-testid="contact-form">
        <input required placeholder="Name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} className="border-b border-neutral-300 py-3" data-testid="contact-name"/>
        <input required type="email" placeholder="Email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} className="border-b border-neutral-300 py-3" data-testid="contact-email"/>
        <textarea required rows="6" placeholder="Message" value={form.message} onChange={e=>setForm({...form,message:e.target.value})} className="border-b border-neutral-300 py-3" data-testid="contact-message"/>
        <button className="hb-btn-primary w-fit" data-testid="contact-submit">Send Message</button>
      </form>}
    </div>
  );
}
